var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mdi-light:delete",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 2.000000)",
    fill: "#D14925"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5,16.5 C14.5,18.1568542 13.1568542,19.5 11.5,19.5 L4.5,19.5 C2.84314575,19.5 1.5,18.1568542 1.5,16.5 L1.5,4.5 L0.5,4.5 L0.5,1.5 L5,1.5 L6,0.5 L10,0.5 L11,1.5 L15.5,1.5 L15.5,4.5 L14.5,4.5 L14.5,16.5 Z M2.5,4.5 L2.5,16.5 C2.5,17.6045695 3.3954305,18.5 4.5,18.5 L11.5,18.5 C12.6045695,18.5 13.5,17.6045695 13.5,16.5 L13.5,4.5 L2.5,4.5 Z M14.5,3.5 L14.5,2.5 L10.5,2.5 L9.5,1.5 L6.5,1.5 L5.5,2.5 L1.5,2.5 L1.5,3.5 L14.5,3.5 Z M4.5,6.5 L5.5,6.5 L5.5,16.5 L4.5,16.5 L4.5,6.5 Z M10.5,6.5 L11.5,6.5 L11.5,16.5 L10.5,16.5 L10.5,6.5 Z",
    id: "Icon-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.4a79faa7076b1040b6ba7e1cefdd68d5.svg";
export { ForwardRef as ReactComponent };